export default "__VITE_ASSET__DsCPOEal__"